<template>
  <div
    class="tw:absolute tw:top-0 tw:left-0 tw:right-0 tw:h-28 tw:rounded-t-lg tw:flex tw:items-center tw:justify-center tw:gap-8 tw:overflow-hidden tw:animate-gradient-shift tw:tour-gradient-bg"
  >
    <div class="tw:relative tw:flex tw:items-center tw:justify-center tw:gap-8">
      <TourStepButton
        v-for="(step, index) in steps"
        :key="step.id"
        :step="step"
        :index="index"
        :current-step-index="currentStepIndex"
        @click="$emit('step-click', index)"
      />
    </div>

    <TourStepConnector :current-step-index="currentStepIndex" :total-steps="steps.length" />
  </div>
</template>

<script lang="ts" setup>
import { TourStep } from "./TourSlider.constants";
import TourStepButton from "./TourStepButton.vue";
import TourStepConnector from "./TourStepConnector.vue";

defineProps<{
  steps: TourStep[];
  currentStepIndex: number;
}>();

defineEmits<{
  (e: "step-click", index: number): void;
}>();
</script>
